import { useEffect, useMemo, useState } from 'react'

type Purchase = {
  id: number
  user_name: string
  product_name: string
  amount: number
  at?: string | null
}

function formatPurchaseAt(iso: string | null | undefined) {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleString('vi-VN', {
    hour: '2-digit',
    minute: '2-digit',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
}

export function PurchasePopups({ items }: { items: Purchase[] }) {
  const list = useMemo(
    () => items.filter((p) => p.user_name && p.product_name),
    [items],
  )
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!list.length) return

    let hideTimer: number | undefined
    let cycleTimer: number | undefined
    let cancelled = false

    const showNext = (i: number) => {
      if (cancelled) return
      setIndex(i % list.length)
      setVisible(true)
      hideTimer = window.setTimeout(() => {
        if (cancelled) return
        setVisible(false)
        cycleTimer = window.setTimeout(() => {
          showNext(i + 1)
        }, 900 + Math.random() * 1200)
      }, 4200)
    }

    const start = window.setTimeout(() => showNext(0), 800)

    return () => {
      cancelled = true
      window.clearTimeout(start)
      window.clearTimeout(hideTimer)
      window.clearTimeout(cycleTimer)
    }
  }, [list])

  if (!list.length) return null

  const p = list[index % list.length]!
  const when = formatPurchaseAt(p.at)

  return (
    <div
      className={`purchase-pop${visible ? ' show' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Đơn gần đây"
    >
      <span className="purchase-pop-icon" aria-hidden>
        <i className="fa-solid fa-bag-shopping" />
      </span>
      <span className="purchase-pop-body">
        {when ? (
          <time className="purchase-pop-time" dateTime={p.at || undefined}>
            <i className="fa-regular fa-clock" aria-hidden /> {when}
          </time>
        ) : null}
        <b>{p.user_name}</b> vừa mua <b>{p.product_name}</b>
        <em>{Number(p.amount).toLocaleString('vi-VN')} đ</em>
      </span>
    </div>
  )
}
